import { type ComponentPropsWithRef } from 'react';

import { clsx } from '../../../lib/clsx';

import styles from './RadioIndicator.module.css';

interface RadioIndicatorProps extends Omit<ComponentPropsWithRef<'span'>, 'children'> {
  isSelected: boolean;
  isDisabled?: boolean;
  isFocusVisible?: boolean;
}

/**
 * Round radio button circle with a dot when selected. It is only the visual, so render it next to
 * a visually hidden radio input.
 */
export function RadioIndicator(props: RadioIndicatorProps) {
  const { className, isSelected, isDisabled, isFocusVisible, ...spanProps } = props;

  return (
    <span
      {...spanProps}
      ref={props.ref}
      className={clsx(styles.root, className)}
      aria-hidden="true"
      data-is-selected={isSelected}
      data-is-disabled={isDisabled ?? false}
      data-is-focus-visible={isFocusVisible ?? false}
    />
  );
}
